module.exports = __webpack_public_path__ + "static/img/Challenge Coin 1-3.75f8c2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Challenge Coin 1-3.jpg
// module id = hiBz
// module chunks = 1